import React from "react";
import { Button } from "./ui/button";

const Hero = () => {
  const scrollToContact = () => {
    const contactSection = document.querySelector("#contact");
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="hero-section">
      <div className="hero-container">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-headline">
              Experience meets Innovation
            </h1>
            <p className="hero-subheadline">
              We pair the judgment of seasoned professionals with the agility of rising talent — delivering resource solutions that are sharp, adaptable, and built for today's challenges for IT professionals seeking premium opportunities with financial institutions, government and enterprise clients.
            </p>
            <div className="hero-benefits">
              <div className="benefit-row">
                <div className="benefit-item">
                  <span className="benefit-icon">💰</span>
                  <span>Better rates, lower margins</span>
                </div>
                <div className="benefit-item">
                  <span className="benefit-icon">🏛️</span>
                  <span>Security clearance pathways</span>
                </div>
              </div>
              <div className="benefit-row">
                <div className="benefit-item">
                  <span className="benefit-icon">⚡</span>
                  <span>Strategic partnerships</span>
                </div>
                <div className="benefit-item">
                  <span className="benefit-icon">🎯</span>
                  <span>Expert matching</span>
                </div>
              </div>
            </div>
            <div className="hero-buttons">
              <Button 
                size="lg" 
                className="btn-primary"
                onClick={scrollToContact}
              >
                Find Talent
              </Button>
              <Button 
                size="lg" 
                className="btn-primary"
                onClick={scrollToContact}
              >
                Join Our Network
              </Button>
            </div>
          </div>
          <div className="hero-image">
            <img 
              src="https://images.unsplash.com/photo-1600880292089-90a7e086ee0c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHx0ZWFtJTIwY29sbGFib3JhdGlvbnxlbnwwfHx8fDE3NTgxODgwMTl8MA&ixlib=rb-4.1.0&q=85"
              alt="Professional team collaboration"
              className="hero-img"
              loading="eager"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
